import { createClient } from '@supabase/supabase-js';

import { env } from '@/config/env';

/**
 * The one and only Supabase client. Only this module and the repository
 * (`api`) layer may import it — enforced by ESLint no-restricted-imports.
 * The anon key is public-by-design; Row-Level Security protects data.
 */
export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});
